var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "footer_top"
  }, [_c("div", {
    staticClass: "footer_top_text"
  }, [_vm._v("现在预约，申请免费试用")]), _c("div", {
    staticClass: "footer_top_button",
    on: {
      click: _vm.handleAppoint
    }
  }, [_vm._m(0)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", [_vm._v("立即预约")]), _c("img", {
    attrs: {
      src: require("@/assets/images/right-arrow2.png"),
      alt: "arrow"
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };